import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderPaymentRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("workorderpayment");
